import { useState, useRef, useEffect } from 'react'
import { useOpcionesColaboradores } from '@/shared/datos/useOpciones'
import { IconoColaborador, IconoCerrar } from '@/shared/ui/Iconos/Iconos'
import estilos from './PlanProyectos.module.css'

type PropsSelector = {
  colaboradoresIds: string[]
  onGuardar: (nuevosIds: string[]) => void
  onCancelar?: () => void
  disabled?: boolean
}

export function SelectorColaboradoresModulo({
  colaboradoresIds = [],
  onGuardar,
  onCancelar,
  disabled = false,
}: PropsSelector) {
  const [abierto, setAbierto] = useState(false)
  const [seleccionados, setSeleccionados] = useState<string[]>(colaboradoresIds)
  const { opciones, cargando } = useOpcionesColaboradores()
  const contenedorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setSeleccionados(colaboradoresIds)
  }, [colaboradoresIds])

  useEffect(() => {
    function clickAfuera(e: MouseEvent) {
      if (contenedorRef.current && !contenedorRef.current.contains(e.target as Node)) {
        if (abierto) {
          cancelar()
        }
      }
    }
    if (abierto) {
      document.addEventListener('mousedown', clickAfuera)
    }
    return () => {
      document.removeEventListener('mousedown', clickAfuera)
    }
  }, [abierto, colaboradoresIds])

  function alternarColaborador(id: string) {
    setSeleccionados((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    )
  }

  function confirmar() {
    setAbierto(false)
    onGuardar(seleccionados)
  }

  function cancelar() {
    setAbierto(false)
    setSeleccionados(colaboradoresIds)
    onCancelar?.()
  }

  const cantidad = seleccionados.length
  const textoBoton =
    cantidad === 0
      ? 'Asignar técnicos'
      : cantidad === 1
      ? '1 técnico asignado'
      : `${cantidad} técnicos asignados`

  return (
    <div className={estilos.colaboradoresContenedor} ref={contenedorRef}>
      <button
        type="button"
        disabled={disabled}
        className={`${estilos.btnAbrirColaboradores} ${
          cantidad > 0 ? estilos.btnAbrirColaboradoresConAsignados : ''
        }`}
        onClick={() => {
          if (abierto) {
            cancelar()
          } else {
            setAbierto(true)
          }
        }}
        title="Asignar colaboradores a este módulo"
      >
        <span className={estilos.colaboradoresEtiqueta}>
          <span className={estilos.iconoColaboradorSvg}>
            <IconoColaborador />
          </span>
          {textoBoton}
        </span>
        <span style={{ fontSize: '0.68rem', color: '#ffc43f' }}>
          {abierto ? '▲' : '▼'}
        </span>
      </button>

      {abierto && (
        <div className={estilos.colaboradoresPopOver}>
          <div className={estilos.popOverTitulo}>
            <span>Colaboradores</span>
            <button
              type="button"
              onClick={cancelar}
              style={{
                background: 'none',
                border: 'none',
                color: '#b9abe0',
                cursor: 'pointer',
                padding: '2px',
                display: 'flex',
              }}
              title="Cerrar y guardar"
            >
              <IconoCerrar />
            </button>
          </div>

          <div className={estilos.popOverLista}>
            {cargando ? (
              <p style={{ fontSize: '0.75rem', color: '#b9abe0', margin: '4px' }}>
                Cargando nómina...
              </p>
            ) : opciones.length === 0 ? (
              <p style={{ fontSize: '0.75rem', color: '#b9abe0', margin: '4px' }}>
                Sin colaboradores disponibles
              </p>
            ) : (
              opciones.map((op) => {
                const activo = seleccionados.includes(op.valor)
                return (
                  <label key={op.valor} className={estilos.popOverItem}>
                    <input
                      type="checkbox"
                      checked={activo}
                      onChange={() => alternarColaborador(op.valor)}
                    />
                    <span className={estilos.popOverItemNombre} title={op.etiqueta}>
                      {op.etiqueta}
                    </span>
                  </label>
                )
              })
            )}
          </div>

          <div className={estilos.popOverFooter}>
            <button
              type="button"
              className={estilos.popOverBtnCancelar}
              onClick={cancelar}
            >
              Cancelar
            </button>
            <button
              type="button"
              className={estilos.popOverBtnConfirmar}
              onClick={confirmar}
            >
              Confirmar
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
